let i = 0;
export default function formatData(
	data,
	dzialId = null,
	tagId = null,
	key = "dzial",
	relatedKey = "dzial_related",
) {
	data.forEach((item) => {
		item.index = i;
		item.dzialId = dzialId;
		item.tagId = tagId;
		item.title = item[key];
		item.relatedItems = item[relatedKey] || [];
		i++;
		if (item.dzial_related?.length) {
			formatData(
				item.dzial_related,
				item.index,
				null,
				"tag",
				"tagdzial_related",
			);
		}

		if (item.tagdzial_related?.length) {
			formatData(item.tagdzial_related, dzialId, item.index, "subtag");
		} else {
			item.tagdzial_related = [];
		}
	});

	return data;
}

export function formatArticles(data, dzialName = null, tagName = null) {
	data.forEach((item) => {
		item.index = i;
		item.dzialName = dzialName;
		item.tagName = tagName;
		i++;
		if (item.artykul_dzialy_related?.length) {
			formatArticles(item.artykul_dzialy_related, item.dzial);
		}

		if (item.tag_dzial_artykul_related?.length) {
			formatArticles(item.tag_dzial_artykul_related, item.dzial);
		}

		if (item.artykul_tagi_related?.length) {
			formatArticles(item.artykul_tagi_related, dzialName, item.tag);
		}
	});

	return data;
}
